import { render, staticRenderFns } from "./ClientSettingsNav.vue?vue&type=template&id=7016ff26&scoped=true"
import script from "./ClientSettingsNav.vue?vue&type=script&lang=ts"
export * from "./ClientSettingsNav.vue?vue&type=script&lang=ts"
import style0 from "./ClientSettingsNav.vue?vue&type=style&index=0&id=7016ff26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7016ff26",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/client-settings-nav.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2FClientSettingsNav.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports